<video #playerEl controls="controls" class="preview-object" [class.hidden]="invalidMedia" controlsList="nodownload noremoteplayback"></video>

<default-preview *ngIf="invalidMedia"></default-preview>